// Transcrição dos calendários acadêmicos Medicina BH 2026 fornecidos.
// Cada linha: data inicial | data final (opcional) | descrição.
const firstToEighth = `
2026-01-01||Confraternização universal
2026-02-02||Início do 1º semestre letivo (todos os períodos)
2026-02-02||Início do 1º Bloco Temático
2026-02-02||Início das atividades de Nivelamento
2026-02-03|2026-02-13|Período para solicitação de troca de turma (com efetivação no segundo bloco)
2026-02-09|2026-02-13|Matrícula em Disciplina Optativa e Atex
2026-02-06||Data limite para finalização de negociação na Tesouraria
2026-02-13||Data limite para solicitação de abertura ou trancamento de matrícula, alteração ou solicitação de matrícula planejada
2026-02-13||Data limite para solicitação de aproveitamento de estudos
2026-02-16|2026-02-18|Feriado e Recesso de Carnaval e Cinzas
2026-02-23||Início das disciplinas optativas e Atex
2026-02-27||Data da expedição das Portarias de trancamento Ex officio
2026-03-06||Término do 1º Bloco Temático
2026-03-09||Início do 2º Bloco Temático
2026-03-14||Data limite para cancelamento de matrícula em disciplina optativa e ATEX
2026-03-20||Bloqueio de lançamento de notas do 1º Bloco temático pelo docente
2026-03-31||Avaliação Integrada
2026-04-02|2026-04-04|Feriado e Recesso da Semana Santa
2026-04-10||Término do 2º Bloco Temático
2026-04-13||Início do 3º Bloco Temático
2026-04-21||Feriado de Tiradentes
2026-04-27||Bloqueio de lançamento de notas do 2º Bloco temático pelo docente
2026-05-01||Feriado Dia do Trabalhador
2026-05-14||Avaliação Integradora do Curso
2026-05-15||Término do 3º Bloco Temático
2026-05-18||Início do 4º Bloco Temático
2026-05-29||Bloqueio de lançamento de notas do 3º Bloco temático pelo docente
2026-06-04|2026-06-05|Feriado e Recesso de Corpus Christi
2026-06-19||Término do 4º bloco
2026-06-19|2026-06-22|Data limite para solicitação de avaliação substitutiva do 1º ao 4º blocos
2026-06-19||Fim das atividades de Nivelamento
2026-06-22|2026-06-25|OSCE
2026-06-26||Provas substitutivas
2026-06-29||Provas substitutivas
2026-06-30||Provas substitutivas
2026-06-29|2026-07-10|Reposição de ambulatórios
2026-06-29|2026-07-03|Capacitação docente do 1º semestre e reuniões operacionais
2026-07-01||Bloqueio de lançamento de notas do 4º Bloco temático pelo docente
2026-07-06||Exame Final Multiestratégia
2026-07-07||Exame Final Multiestratégia
2026-07-09||Data limite para solicitação de revisão do Exame Final Multiestratégia
2026-07-10||Término do 1º Semestre Letivo: encerramento das atividades acadêmicas
2026-07-13|2026-07-27|Recesso Acadêmico (Estudantes e Professores)
2026-07-28||Início do 2º Semestre Letivo
2026-07-28|2026-07-31|Capacitação docente do 2º semestre e reuniões operacionais
2026-08-04|2026-08-14|Período para solicitação de troca de turma
2026-08-10|2026-08-14|Matrícula em Disciplina Optativa e Atex
2026-08-07||Data limite para finalização de negociação na Tesouraria
2026-08-14||Data limite para pagamento da rematrícula 2026/2
2026-08-14||Data limite para solicitação de abertura de matrícula, alteração de matrícula planejada e aproveitamento de estudos
2026-08-15||Feriado Municipal - Nossa Sra da Boa Viagem
2026-08-21||Término do 1º Bloco Temático
2026-08-21||Data da expedição das Portarias de trancamento ex officio
2026-08-22||Sábado letivo
2026-08-24||Início das Disciplinas Optativas e Atex
2026-08-24||Início do 2º Bloco Temático
2026-09-04||Bloqueio de lançamento de notas do 1º Bloco temático pelo docente
2026-09-07||Feriado da Independência do Brasil
2026-09-18||Data limite para cancelamento de matrícula em disciplina optativa e ATEX
2026-09-25||Término do 2º Bloco Temático
2026-09-28||Início do 3º Bloco Temático
2026-10-09||Bloqueio de lançamento de notas do 2º Bloco temático pelo docente
2026-10-10||Sábado letivo
2026-10-12||Feriado de Nossa Senhora Aparecida
2026-10-15||Dia do Professor
2026-10-30||Término do 3º Bloco Temático
2026-11-02||Feriado de Finados
2026-11-03||Início do 4º Bloco Temático
2026-11-13||Bloqueio de lançamento de notas do 3º Bloco temático pelo docente
2026-11-15||Feriado da Proclamação da República
2026-11-20||Feriado Dia Nacional da Consciência Negra
2026-11-23|2026-11-26|Data limite para solicitação de avaliação substitutiva do 1º e 2º blocos
2026-12-04|2026-12-07|Data limite para solicitação de avaliação substitutiva do 3º e 4º blocos
2026-12-04||Término do 4º Bloco Temático
2026-12-05||Provas substitutivas do 1º e 2º Blocos Temáticos e Substitutiva da Avaliação Integradora do Curso
2026-12-07|2026-12-11|OSCE
2026-12-08||Feriado Municipal - Dia de Nossa Sra da Imaculada Conceição
2026-12-12||Provas substitutivas do 3º e 4º Blocos Temáticos
2026-12-14||Bloqueio de lançamento de notas do 4º Bloco temático pelo docente
2026-12-16|2026-12-17|Exame Final Multiestratégia
2026-12-18||Término do 1º Semestre Letivo: encerramento das atividades acadêmicas
2026-12-24|2026-12-31|Recesso Acadêmico (Estudantes e Professores)
`;

const ninthToTwelfth = `
2026-01-01||Confraternização universal
2026-02-02||Início do 1º semestre letivo (todos os períodos)
2026-02-02||Início do 1º rodízio (todos os internatos)
2026-02-06||Data limite para finalização de negociação na Tesouraria
2026-02-13||Período para confirmação das disciplinas em que está matriculado (sistema acadêmico)
2026-02-13||Data limite para solicitação de abertura ou trancamento de matrícula, alteração ou solicitação de matrícula planejada
2026-02-16|2026-02-18|Feriado de Carnaval e Cinzas (escala de plantão de acordo com o cenário)
2026-02-20||Data da expedição das Portarias de trancamento Ex officio
2026-03-31||Avaliação Integrada
2026-04-02|2026-04-04|Feriado da Semana Santa (escala de plantão de acordo com o cenário)
2026-04-06|2026-04-10|Prova final 1º rodízio (todos os internatos)
2026-04-10||Término do 1º rodízio (todos os internatos)
2026-04-10||Solicitação de prova substitutiva do 1º rodízio (todos os internatos)
2026-04-13||Início do 2º rodízio (todos os internatos)
2026-04-21||Feriado de Tiradentes (escala de plantão de acordo com o cenário)
2026-04-24||Bloqueio de lançamento de notas do 1º rodízio do internato pelo docente
2026-05-01||Feriado Dia do Trabalhador (escala de plantão de acordo com o cenário)
2026-05-14||Avaliação Integradora do Curso
2026-06-04|2026-06-05|Feriado de Corpus Christi (escala de plantão de acordo com o cenário)
2026-06-17|2026-06-18|Prova final 2º rodízio (todos os internatos)
2026-06-19||Término do 2º rodízio (todos os internatos)
2026-06-19||Solicitação de prova substitutiva do 2º rodízio (todos os internatos)
2026-06-22|2026-06-25|Provas substitutivas do 2º rodízio
2026-06-26||Exame Final Multiestratégia
2026-06-29|2026-07-03|Capacitação docente do 1º semestre e reuniões operacionais
2026-06-29|2026-07-10|Reposição de ambulatórios
2026-06-30||Data limite para solicitação de revisão do Exame Final Multiestratégia
2026-07-03||Bloqueio de lançamento de notas do 2º rodízio do internato pelo docente
2026-07-10||Término do 1º Semestre Letivo: encerramento das atividades acadêmicas
2026-07-13|2026-07-27|Recesso Acadêmico (Estudantes e Professores)
2026-07-28||Início do 2º Semestre Letivo
2026-07-28|2026-07-31|Capacitação docente do 2º semestre e reuniões operacionais
2026-08-07||Data limite para finalização de negociação na Tesouraria
2026-08-14||Data limite para pagamento da rematrícula 2026/2
2026-08-14||Data limite para solicitação de abertura de matrícula e alteração de matrícula planejada
2026-08-15||Feriado Municipal - Nossa Sra da Boa Viagem (escala de plantão de acordo com o cenário)
2026-08-21||Data da expedição das Portarias de trancamento ex officio
2026-08-22||Sábado Letivo
2026-09-07||Feriado da Independência do Brasil (escala de plantão de acordo com o cenário)
2026-09-29|2026-10-02|Provas Finais do 1º Rodízio (todos os internatos)
2026-09-12||Sábado Letivo
2026-10-02||Data para solicitação de provas substitutivas do 1º Rodízio (todos os internatos)
2026-10-02||Término do 1º Rodízio (todos os internatos)
2026-10-05||Início do 2º Rodízio (todos os internatos)
2026-10-10||Provas substitutivas do 1º Rodízio (todos os internatos), incluindo teste de progresso
2026-10-10||Sábado Letivo
2026-10-12||Feriado de Nossa Senhora Aparecida
2026-10-15||Dia do Professor
2026-10-16||Bloqueio de lançamento de notas do 1º rodízio do internato pelo docente
2026-10-17||Sábado Letivo
2026-11-02||Feriado de Finados (escala de plantão de acordo com o cenário)
2026-11-07||Sábado Letivo
2026-11-15||Proclamação da República (escala de plantão de acordo com o cenário)
2026-11-20||Feriado Dia Nacional da Consciência Negra (escala de plantão de acordo com o cenário)
2026-11-28||Sábado Letivo
2026-12-01|2026-12-04|Provas Finais do 2º Rodízio (todos os internatos)
2026-12-04||Data para solicitação de provas substitutivas do 2º Rodízio
2026-12-04||Término do 2º Rodízio (todos os internatos)
2026-12-05||Sábado Letivo
2026-12-05|2026-12-09|Provas substitutivas do 2º Rodízio (todos os internatos), incluindo substitutiva da Avaliação Integradora
2026-12-08||Feriado Municipal - Dia de Nossa Sra da Imaculada Conceição
2026-12-10||Exame Final Multiestratégia
2026-12-14||Bloqueio de lançamento de notas do 2º rodízio do internato pelo docente
2026-12-18||Término do 1º Semestre Letivo: encerramento das atividades acadêmicas
2026-12-24|2026-12-31|Recesso Escolar
`;

const kindFor = (title) => {
  if (/feriado|recesso|confraternização|dia do professor|proclamação da república/i.test(title)) return 'holiday';
  if (/avaliação|prova|exame|osce|teste de progresso/i.test(title)) return 'assessment';
  return 'academic';
};

const parseEvents = (source) => source.trim().split('\n').map((line) => {
  const [start, end, title] = line.split('|');
  return { start, end: end || start, title, kind: kindFor(title) };
});

export const calendarEvents = {
  '1-8': parseEvents(firstToEighth),
  '9-12': parseEvents(ninthToTwelfth),
};
